import React from 'react';
import { Phone } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

export const CoverageCTA = ({
  heading,
  subtext = "Coverage with purpose. Let's protect what matters most. Speak with a licensed representative at Purposefully Covered Insurance Group today.",
}) => (
  <section className="py-8 bg-brand-blue text-white" data-testid="coverage-cta">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-6">{heading}</h2>
      <p className="text-lg mb-8 max-w-2xl mx-auto">{subtext}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href={`tel:${companyInfo.phoneRaw}`}
          className="inline-flex items-center gap-2 bg-brand-orange text-white px-8 py-4 rounded-md hover:bg-brand-orange-light transition font-semibold text-lg"
          data-testid="coverage-cta-call"
        >
          <Phone size={20} /> Call {companyInfo.phone}
        </a>
        <a
          href="/#quote"
          className="inline-flex items-center gap-2 bg-white text-brand-blue px-8 py-4 rounded-md hover:bg-gray-100 transition font-semibold text-lg"
          data-testid="coverage-cta-quote"
        >
          Get My Free Quote
        </a>
      </div>
    </div>
  </section>
);

export default CoverageCTA;
